import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.bonus_state,
    props.user.currency,
    props.user.buttons.take_bonus,
    (bonus_state, currency, button) => {
        let stars_count = 0;
        if(bonus_state && bonus_state.daily.online.claimed) stars_count++;
        if(bonus_state && bonus_state.daily.total_slots.claimed) stars_count++;
        if(bonus_state && bonus_state.daily.total_fishing.claimed) stars_count++;
        if(bonus_state && bonus_state.weekly.online.claimed) stars_count++;
        if(bonus_state && bonus_state.weekly.total_slots.claimed) stars_count++;
        if(bonus_state && bonus_state.weekly.total_fishing.claimed) stars_count++;

        return {
            bonus_state,
            currency,
            button,
            stars_count
        }
    }
)